var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[_c('HeaderTop',{on:{"save":_vm.save}}),_c('Navigation')],1),_c('Login',{ref:"login"}),_c('Age')],1)}
var staticRenderFns = []

export { render, staticRenderFns }